import { darken, lighten, parseToRgb } from 'polished'
import { useTheme } from 'styled-components'
import { useHeaderNotice } from '@/providers/headerNoticeProvider'

type PromoAccentColors = {
  base: string
  light: string
  dark: string
}

const isParsableColor = (color: string): boolean => {
  if (!color) {
    return false
  }
  try {
    parseToRgb(color)
    return true
  } catch {
    return false
  }
}

export const usePromoAccentColors = (): PromoAccentColors => {
  const theme = useTheme()
  const headerNotice = useHeaderNotice()

  const base = isParsableColor(headerNotice?.backgroundColor)
    ? headerNotice.backgroundColor
    : theme.colors.stockDiscountColor

  return {
    base,
    light: lighten(0.15, base),
    dark: darken(0.08, base)
  }
}
